import { useQuery, NetworkStatus } from '@apollo/client';

import { SEARCH_BOOKS } from './queries';

import Box from '../../components/layout/Box';
import BookList from '../../components/BookList';
import FullScreenLoader from '../../components/FullScreenLoader';
import EmptySearch from './EmptySearch';

const SearchBooks = ({ searchString }) => {
  const limit = 10;

  const { data, loading, fetchMore, networkStatus } = useQuery(SEARCH_BOOKS, {
    notifyOnNetworkStatusChange: true,
    variables: {
      searchString,
      pagination: {
        offset: 0,
        limit,
      },
      sorting: {
        orderBy: 'id',
        order: 'DESC',
      },
    },
  });

  if (!loading && data?.listBooks?.length === 0) {
    return (
      <Box className="flex-column flex-grow-1">
        <EmptySearch />
      </Box>
    );
  }

  return (
    <Box className="flex-grow-1 flex-column">
      {loading && networkStatus === NetworkStatus.loading ? (
        <FullScreenLoader />
      ) : (
        <BookList
          items={data?.listBooks || []}
          fetchMore={fetchMore}
          networkStatus={networkStatus}
          loading={loading}
          limit={limit}
        />
      )}
    </Box>
  );
};

export default SearchBooks;
